import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import { Body, HeadlineM, Overline, Subtitle } from 'components/Text'
import media from 'styles/media'
import Colors from 'styles/Colors'

import { ReactComponent as ArrowSVG } from 'svg/arrowSmall.svg'
import { ArrowButton } from 'components/Buttons'

const SupportHub: React.FC<{}> = () => {
  const categories = [
    {
      title: 'Technical Support',
      description: 'Need assistance? Let our support specialist help you out.',
      buttonText: 'Contact support',
      link: '/tech-support',
    },
    {
      title: 'Provide feedback',
      description: 'Help us get better. Submit feedback or raise an issue.',
      buttonText: 'Give feedback',
      link: '/ticket',
    },
    {
      title: 'Documentation',
      description:
        'View online documentation and become an expert with our products.',
      buttonText: 'Access docs',
      link: 'http://docs.rtr.ai',
      outbound: true,
    },
    {
      title: 'Download files',
      description: 'Get access and download all the files you need.',
      buttonText: 'Access files',
      link: 'http://files.rtr.ai',
      outbound: true,
    },
  ]
  return (
    <Wrapper>
      <Label bullet>Technical support</Label>
      <Title>Get in touch with one of our support specialists </Title>
      <Subtitle>Choose a category</Subtitle>
      <Categories>
        {categories.map((category) => {
          return (
            <Link
              key={category.title}
              to={category.link}
              aria-label={category.title}
              target={category.outbound && '_blank'}
              rel={category.outbound && 'noreferrer noopener'}
            >
              <Category>
                <CategoryTitle>{category.title}</CategoryTitle>
                <Paragraph>{category.description}</Paragraph>
                <Button>{category.buttonText}</Button>
              </Category>
            </Link>
          )
        })}
      </Categories>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 732px;
  margin: 196px auto 0;
  ${media.mobile} {
    width: calc(100% - 24px);
  }
`
const Label = styled(Overline)`
  ::after {
    color: ${Colors.blueYonder};
  }
`
const Title = styled(HeadlineM)`
  margin: 15px 0 96px;
  ${media.mobile} {
    font-size: 36px;
    margin-bottom: 48px;
  }
  ${media.fullWidth} {
    font-size: 54px;
  }
`
const Categories = styled.nav`
  margin-top: 24px;
`
const Category = styled.div`
  width: 100%;
  min-height: 120px;
  background: white;
  padding: 22px 187px 16px 79px;
  margin-bottom: 24px;
  position: relative;
  ${media.mobile} {
    padding: 22px 12px 48px 43px;
  }
`
const CategoryTitle = styled(Subtitle)`
  position: relative;
  margin-bottom: 6px;
  ${media.fullWidth} {
    font-size: 24px;
    line-height: 28px;
  }
  ::before {
    content: '//';
    position: absolute;
    color: ${Colors.blueYonder};
    left: -31px;
  }
`
const Paragraph = styled(Body)`
  max-width: 390px;
  ${media.fullWidth} {
    font-size: 16px;
  }
`

const Button = styled(ArrowButton)`
  position: absolute;
  top: calc(50% - 14px);
  right: 48px;
  transition: 0.4s;
  transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
  border: none;
  background: transparent;
  displau: flex;
  cursor: pointer;
  color: ${Colors.softBlack};
  font-size: 16px;
  font-weight: 500;
  padding: 0;
  :hover {
    right: 44px;
  }
  ${media.mobile} {
    top: auto;
    bottom: 12px;
    right: auto;
    left: 43px;
    padding: 0;
    :hover {
      right: 8px;
      color: ${Colors.softBlack48};
    }
  }
`

export default SupportHub
